import { MatIconModule } from '@angular/material/icon';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnChanges, OnDestroy, TemplateRef, Type, ViewChild, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DatePipe } from '@angular/common';
import { ComponentType } from '@angular/cdk/portal';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { DoCheck, KeyValueDiffer, KeyValueDiffers } from '@angular/core';
import { environment } from 'environments/environment';

interface DatepickerProps extends FormlyFieldProps {
      spidlock?: boolean;
      datepickerOptions?: Partial<{
      touchUi: boolean;
      opened: boolean;
      disabled: boolean;
      startView: 'month' | 'year' | 'multi-year';
      datepickerTogglePosition: 'suffix' | 'prefix';
      calendarHeaderComponent: ComponentType<any>;
      filter: (date: any | null) => boolean;
      min: any;
      max: any;
      dateInput: (field: FieldTypeConfig<DatepickerProps>, event: any) => void;
      dateChange: (field: FieldTypeConfig<DatepickerProps>, event: any) => void;

      monthSelected: (field: FieldTypeConfig<DatepickerProps>, event: any, picker: MatDatepicker<any>) => void;
      yearSelected: (field: FieldTypeConfig<DatepickerProps>, event: any, picker: MatDatepicker<any>) => void;

      panelClass: string | string[];
      startAt: any | null;
    }>;
  }

  export interface FormlyDatepickerFieldConfig extends FormlyFieldConfig<DatepickerProps> {
    type: 'mat-datepicker' | Type<MatDatepickerTypeComponent>;
  }


@Component({
  selector: 'formly-datepicker',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone     : true,
  imports: [
    MatIconModule,
    FormlyModule,
    MatInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    DatePipe
  ],
  template: `
    @if (formState.editMode  && !spidLock) {
    <input
      matInput
      [id]="id"
      [name]="field.name"
      [type]="type || 'text'"
      [readonly]="props.readonly"
      [required]="required"
      [errorStateMatcher]="errorStateMatcher"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [tabIndex]="props.tabindex"
      [min]="props.datepickerOptions.min"
      [max]="props.datepickerOptions.max"
      [placeholder]="props.placeholder"
      [matDatepickerFilter]="props.datepickerOptions.filter"
      [matDatepicker]="picker"
    />
    <ng-template #datepickerToggle >
      <mat-datepicker-toggle
        matIconSuffix
        (click)="detectChanges()"
        [disabled]="props.disabled"
        [for]="picker"
      ></mat-datepicker-toggle>
    </ng-template>
    <mat-datepicker
      #picker
      [color]="props.color"
      [dateClass]="props.datepickerOptions.dateClass"
      [disabled]="props.datepickerOptions.disabled"
      [opened]="props.datepickerOptions.opened"
      [panelClass]="props.datepickerOptions.panelClass"
      [startAt]="props.datepickerOptions.startAt"
      [startView]="props.datepickerOptions.startView"
      [touchUi]="props.datepickerOptions.touchUi"
      [calendarHeaderComponent]="props.datepickerOptions.calendarHeaderComponent"
      (monthSelected)="props.datepickerOptions.monthSelected(field, $event, picker)"
      (yearSelected)="props.datepickerOptions.yearSelected(field, $event, picker)"
      (opened)="props.datepickerOptions.opened = true"
      (closed)="props.datepickerOptions.opened = false"
    >
    </mat-datepicker>
    }
    @else{
        <p>{{field.formControl.value | date:'dd/MM/yyyy'}}</p>
    }
  `
})
export class MatDatepickerTypeComponent extends FieldType<FieldTypeConfig<DatepickerProps>> implements AfterViewInit, OnDestroy {

    @ViewChild('datepickerToggle', { static: false }) datepickerToggle!: TemplateRef<any>;

    override defaultOptions = {
        props: {
          datepickerOptions: {
            startView: 'month' as const,
            datepickerTogglePosition: 'suffix' as const,
            disabled: false,
            opened: false,
            dateInput: () => {},
            dateChange: () => {},
            monthSelected: () => {},
            yearSelected: () => {},
          },
        },
      };

      private differ: KeyValueDiffer<string, any>;

    constructor(private config: FormlyConfig, private cdRef: ChangeDetectorRef,private differs: KeyValueDiffers) {
        super();
        this.differ = this.differs.find({}).create();
    }

    //per vedere se è cambiato il valore di editMode
    ngDoCheck() {
        const changes = this.differ.diff(this.field.options.formState);
        if (changes) {
          changes.forEachChangedItem(item => {
            this.detectChanges();
            if (item.key === 'editMode') {
                if (item.currentValue){
                    this.props[this.props.datepickerOptions.datepickerTogglePosition] = this.datepickerToggle;
                }
                else{
                    this.props[this.props.datepickerOptions.datepickerTogglePosition]=null
                }
            }
          });
        }
    }

    get spidLock(){
      return this.field.options.formState.usermode=='spid' && !(this.field.model?.delega==2 || this.field.model?.tipo_id=='integrazione') && this.field.props.spidlock && environment.comune!="RAPALLO"
    }



    detectChanges() {
        this.options.detectChanges?.(this.field);
        this.cdRef.detectChanges();
    }



    ngAfterViewInit() {
        if (this.field.options.formState.editMode){
            this.props[this.props.datepickerOptions.datepickerTogglePosition] = this.datepickerToggle;
        }
      }


      override ngOnDestroy() {
        super.ngOnDestroy();
      }

}




